import type { BroadcastShift } from '@/entities/chat'

export function defaultGuardIds(shift: BroadcastShift | undefined): number[] {
  if (!shift) return []
  const onDuty = shift.guards.filter((guard) => guard.onDuty).map((guard) => guard.userId)
  return shift.overtime && onDuty.length > 0 ? onDuty : shift.guards.map((guard) => guard.userId)
}

export function isSameGuardSet(selectedIds: number[], rosterIds: number[]): boolean {
  if (selectedIds.length !== rosterIds.length) return false
  const rosterSet = new Set(rosterIds)
  return selectedIds.every((id) => rosterSet.has(id))
}
